import React from 'react';
import { compactMoney } from '../format';

const TILE = 'rounded-xl p-4 flex flex-col gap-1.5';
const TILE_LABEL = 'font-label text-[10px] uppercase tracking-[0.06em]';
const FIGURE = 'font-light tracking-[-0.02em] tabular-nums';
const MULTIPLE = 'font-label text-[11px] text-muted-foreground';

export default function ValueGapBody({ data }) {
  return (
    <div className="flex flex-col gap-5">
      <div className="grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-2.5">
        <div className={`${TILE} bg-muted/30`}>
          <span className={`${TILE_LABEL} text-muted-foreground`}>Current value</span>
          <span className={`${FIGURE} text-[24px]`}>{compactMoney(data.current_value)}</span>
          {data.current_multiple != null && <span className={MULTIPLE}>{Number(data.current_multiple).toFixed(1)}x</span>}
        </div>
        <div className={`${TILE} bg-muted/30`}>
          <span className={`${TILE_LABEL} text-muted-foreground`}>Best-in-class value</span>
          <span className={`${FIGURE} text-[24px] text-teal-ink`}>{compactMoney(data.potential_value)}</span>
          {data.best_in_class_multiple != null && <span className={MULTIPLE}>{Number(data.best_in_class_multiple).toFixed(1)}x</span>}
        </div>
        <div className={`${TILE} bg-succeedo-orange/5 border border-succeedo-orange/20`}>
          <span className={`${TILE_LABEL} text-orange-ink`}>Value gap</span>
          <span className={`${FIGURE} text-[28px] text-orange-ink`}>{compactMoney(data.value_gap)}</span>
          {Array.isArray(data.recoverable_range) && data.recoverable_range[1] > 0 ? (
            <span className={MULTIPLE}>
              Roughly {compactMoney(data.recoverable_range[0])}–{compactMoney(data.recoverable_range[1])} within reach · benchmark estimate
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
